import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'Soy de madera con la tecnología y no tengo conocimientos previos, ¿voy a poder con todo esto?',
  answer: '¡Sí! El programa tiene 30 videos paso a paso donde te mostramos exactamente dónde hacer clic. Y si te llegás a trabar, lo resolvemos juntos compartiendo pantalla en las consultorías en vivo. Más del 95% de los alumnos no tienen conocimientos previos y lograron resultados, vos también podés.'
}, {
  question: '¿Tengo que grabar videos, tener seguidores en Instagram o una marca personal para vender?',
  answer: 'Para nada. Vas a vender en piloto automático usando anuncios del producto que elijas sin conocimientos previos ni marca personal. No necesitás mostrar tu cara, ni tener seguidores, ni estar creando contenido diario.'
}, {
  question: 'Ya compré otros cursos y me dejaron re solo/a. ¿Acá hay soporte real?',
  answer: 'Sí, el acompañamiento es nuestro fuerte. Si entrás con la Consultoría Grupal, tenés llamadas en vivo todas las semanas para destrabarte en el momento y no quedarte nunca a mitad de camino.'
}, {
  question: '¿Qué pasa si no tengo ninguna idea para escribir un ebook?',
  answer: 'No hace falta ser experto. Te damos las instrucciones (prompts) exactas para que la Inteligencia Artificial elija un nicho rentable, lo estructure y escriba todo tu producto en 48 horas.'
}, {
  question: 'Trabajo todo el día, ¿me va a dar el tiempo?',
  answer: '¡Sí! El curso está grabado para que avances a tu propio ritmo. Como la IA y nuestras plantillas hacen el trabajo pesado, con dedicarle un par de horas en tus tiempos libres es suficiente. Y si no podés estar en las consultorías en vivo también quedan grabadas para que las puedas ver luego y resolver dudas.'
}, {
  question: '¿Cuál es la diferencia entre la opción de $34.990 y la de $49.990?',
  answer: 'La de $34.990 incluye el programa grabado paso a paso para que apliques por tu cuenta. La de $49.990 incluye el programa + el acceso a las consultorías semanales en vivo + todos los bonos extras.'
}, {
  question: '¿Cómo cobro la plata de las ventas si estoy en Argentina?',
  answer: 'Súper fácil. Te enseñamos a integrar tu tienda directamente con Mercado Pago para que la plata de tus ventas se acredite en tu cuenta como cualquier otra transacción local.'
}, {
  question: 'Además de la entrada al programa, ¿tengo que invertir más plata?',
  answer: 'Para arrancar necesitás el plan básico de Shopify y tu publicidad. Podés comenzar testeando con solo 30.000 pesos para la primera campaña de testeo, y luego ir reinvirtiendo directamente de las ganancias de las ventas que se generen.'
}, {
  question: '¿En cuánto tiempo voy a ver resultados?',
  answer: 'Si aplicás el paso a paso, en 72 horas tenés tu ebook listo. Muchos alumnos logran sus primeras ventas en las primeras 72hs de encender sus anuncios. Todo depende de tu constancia y compromiso.'
}, {
  question: 'Me da miedo que no me funcione... ¿tienen garantía?',
  answer: '¡Cero riesgo para vos! Tenés una garantía incondicional de 7 días "sin vueltas". Si entrás y sentís que el programa no es para vos, pedís la devolución y te reintegramos el 100% de tu dinero.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-12 md:py-20 px-4 bg-[#121212] pt-[0px] pb-[0px]" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <div className="text-center mb-12" data-id="element-61">
          <h2 className="text-3xl md:text-5xl font-black leading-tight text-[#FFFFFF]" data-id="element-62">
            ❓LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-3" data-id="element-63">
          {faqs.map((faq, index) => <div key={index} className="bg-[#000000] rounded-xl border border-gray-700 overflow-hidden shadow-sm" data-id="element-64">
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between px-6 py-5 text-left gap-4 hover:bg-[#1a1a1a] transition-colors bg-[#000000]" data-id="element-65">
                <span className="text-base md:text-lg font-[500] font-[Inter,_sans-serif] text-[#FFFFFF]" data-id="element-66">
                  {index + 1}. {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-[#9C16A3] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-67" />
              </button>
              <div className={`overflow-hidden transition-all duration-300 bg-[#000000] ${openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-68">
                <p className="px-6 pb-5 text-gray-300 leading-relaxed" data-id="element-69">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}